﻿(() => {
  let activeTabId = '#cart-panel';
  function setActiveTab(drawer, targetId) {
    const inner = drawer.querySelector('.drawer__inner');
    if (!inner) return;
    inner.querySelectorAll('a.drawer__tab-button').forEach(button => {
      const active = button.dataset.tabTarget === targetId;
      button.classList.toggle('active', active);
      button.setAttribute('aria-selected', String(active));
    });
    drawer.querySelectorAll('.drawer__tab-panel').forEach(panel => panel.classList.toggle('active', `#${panel.id}` === targetId));
    if (targetId === '#recent-panel' && typeof window.getRecentPdp === 'function') window.getRecentPdp();
    activeTabId = targetId;
  }
  window.initCartDrawerTabs = drawer => {
    const inner = drawer.querySelector('.drawer__inner');
    if (!inner) return;
    if (!inner.dataset.tabsInitialized) {
      inner.dataset.tabsInitialized = 'true';
      inner.addEventListener('click', event => {
        const link = event.target.closest('a.drawer__tab-button');
        if (!link) return;
        event.preventDefault();
        setActiveTab(drawer, link.dataset.tabTarget);
      });
    }
    setActiveTab(drawer, activeTabId);
  };
  document.addEventListener('DOMContentLoaded', () => {
    const drawer = document.querySelector('cart-drawer');
    if (drawer) window.initCartDrawerTabs(drawer);
    document.getElementById('CartDrawer-Overlay')?.addEventListener('touchmove', event => event.preventDefault(), {passive:false});
  });
})();
